import styled, { css, keyframes } from 'styled-components'

const aiGlowShimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`

const aiGlowTextGradient = css`
  background: linear-gradient(
    90deg,
    ${props => props.theme.palette.product.ai.dark} 0%,
    color-mix(in srgb, ${props => props.theme.palette.product.ai.dark} 70%, ${props => props.theme.palette.product.ai.light} 30%) 25%,
    ${props => props.theme.palette.product.ai.dark} 50%,
    color-mix(in srgb, ${props => props.theme.palette.product.ai.dark} 70%, ${props => props.theme.palette.product.ai.light} 30%) 75%,
    ${props => props.theme.palette.product.ai.dark} 100%
  );
`

const AIGlowText = styled.span<{ displayGlow?: boolean }>`
  ${props => props.displayGlow && css`
    ${aiGlowTextGradient}
    display: block;
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${aiGlowShimmer} 3s linear infinite;
    font-weight: 600;
  `}
`

export default AIGlowText
